import './CommunityEventCard.css';
import NamePill from '../NamePill/NamePill';
import { getImageSrc } from '../../utils/imageUtils';

export default function CommunityEventCard({
  name,
  topic,
  date,
  city,
  speakers = [],
}) {
  const speakerLabel = speakers.filter(Boolean).join(', ');
  const iconBase = process.env.PUBLIC_URL || '';
  const calendarIcon = getImageSrc(`${iconBase}/calendar.svg`);
  const locationIcon = getImageSrc(`${iconBase}/location.svg`);
  const usersIcon = getImageSrc(`${iconBase}/users.svg`);

  return (
    <article className="CommunityEventCard">
      {name ? <NamePill text={name} showGlow className="CommunityEventCard__namePill" /> : null}

      {topic ? <h3 className="CommunityEventCard__topic">{topic}</h3> : null}

      <div className="CommunityEventCard__meta">
        {date ? (
          <div className="CommunityEventCard__metaRow">
            <span className="CommunityEventCard__metaLabel CommunityEventCard__metaLabel--date">
              <img
                className="CommunityEventCard__metaIcon"
                src={calendarIcon}
                alt=""
                aria-hidden="true"
              />
            </span>
            <span className="CommunityEventCard__metaValue">{date}</span>
          </div>
        ) : null}
        {city ? (
          <div className="CommunityEventCard__metaRow">
            <span className="CommunityEventCard__metaLabel CommunityEventCard__metaLabel--city">
              <img
                className="CommunityEventCard__metaIcon"
                src={locationIcon}
                alt=""
                aria-hidden="true"
              />
            </span>
            <span className="CommunityEventCard__metaValue">{city}</span>
          </div>
        ) : null}
        {speakerLabel ? (
          <div className="CommunityEventCard__metaRow">
            <span className="CommunityEventCard__metaLabel CommunityEventCard__metaLabel--speakers">
              <img
                className="CommunityEventCard__metaIcon"
                src={usersIcon}
                alt=""
                aria-hidden="true"
              />
            </span>
            <span className="CommunityEventCard__metaValue">{speakerLabel}</span>
          </div>
        ) : null}
      </div>
    </article>
  );
}
